import{useState as n}from"react";function r(){var r=n(!1),o=r[0],u=r[1];return{bind:{onBlur:function(){return u(!1)},onFocus:function(){return u(!0)},onMouseEnter:function(){return u(!0)},onMouseLeave:function(){return u(!1)}},isHoverFocus:o}}export{r as default};
//# sourceMappingURL=useHoverFocus.js.map
